export const css = {
	oneaction: '_2_Dbj7dd',
	' _key': 'ascm-theme/ascm/quiz-widgets/prometric-review'
};

export default css;
